import { render, staticRenderFns } from "./ViewStockInPrint.vue?vue&type=template&id=96729464&"
import script from "./ViewStockInPrint.vue?vue&type=script&lang=js&"
export * from "./ViewStockInPrint.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports